/* global axios */
import ApiClient from './ApiClient';

class WhatsappContactInsightsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(contactId, params = {}) {
    return axios.get(`${this.url}/${contactId}/whatsapp_insights`, { params });
  }

  subscribePresence(contactId) {
    return axios.post(`${this.url}/${contactId}/subscribe_whatsapp_presence`);
  }

  refreshProfile(contactId, connectionId) {
    return axios.post(`${this.url}/${contactId}/refresh_whatsapp_profile`, {
      connection_id: connectionId,
    });
  }
}

export default new WhatsappContactInsightsAPI();
